import React, { useMemo } from 'react';
import styles from './UIGameTradeCreatorProposal.module.scss';
import { Avatar } from '../../../common/Avatar/index.ts';
import IconTradeArrowRed from '@static/images/icon_trade_arrow_red.svg';
import { cardEnumsToCardState } from '../../../utils/cards.ts';
import { UIGameCardInventory } from '../../../common/UIGameCardInventory/UIGameCardInventory.tsx';
import { UIGameCard } from '../../../common/UIGameCard/index.ts';
import { TradeErrorHighlightLocationEnum } from '@colonist/game-mechanic-validators';
import { MERCHANT_IMAGE_PATH } from '../../../utils/gamePieces.ts';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { usePlayerValidators } from '../../../store/selectors/usePlayerValidators.ts';
import { useCardsToHighlight } from '../useCardsToHighlight.ts';
export const UIGameTradeCreatorProposalOfferedHalf = ({ offeredCards, onClickOfferedCard, isPortraitLayout })=>{
    const gameState = useGameStore((state)=>state.gameState);
    const myColor = useGameStore((state)=>state.myColor);
    const counterOffer = useGameStore((state)=>state.gameTrade.counterOffer);
    const isBankTradeMode = useGameStore((state)=>state.gameTrade.isBankTradeMode);
    const { getPlayerValidator } = usePlayerValidators();
    const isCreatingCounterOffer = counterOffer != null;
    const myPlayerValidator = getPlayerValidator(myColor);
    const offeredCardsState = useMemo(()=>cardEnumsToCardState(offeredCards), [
        offeredCards
    ]);
    const merchantState = gameState.mechanicMerchantState;
    const amIMerchantOwner = (merchantState === null || merchantState === void 0 ? void 0 : merchantState.owner) === myColor;
    const shouldShowBankTradeRatio = isBankTradeMode;
    const myBankTradeRatioState = myPlayerValidator.bankTradeRatiosState;
    const cardsToHighlight = useCardsToHighlight(TradeErrorHighlightLocationEnum.ProposalOffered);
    const shouldShowMerchant = !isCreatingCounterOffer && amIMerchantOwner && merchantState.activeTradeBonus != null;
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.proposalOfferedHalfContainer
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.leftContainer
    }, /*#__PURE__*/ React.createElement(Avatar, {
        image: myPlayerValidator.displayIcon,
        color: myColor,
        profilePictureUrl: myPlayerValidator.profilePictureUrl,
        className: styles.avatar
    }), /*#__PURE__*/ React.createElement("img", {
        src: IconTradeArrowRed,
        className: styles.givingArrow
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles.cardStackContainer
    }, /*#__PURE__*/ React.createElement(UIGameCardInventory, {
        showTipTitle: false,
        showTipBody: false,
        cardState: offeredCardsState,
        onClickCard: onClickOfferedCard,
        animate: true,
        enablePartition: true,
        className: styles.cardStack,
        cardSize: isPortraitLayout ? 'sm' : 'base',
        cardsToHighlight: cardsToHighlight,
        bankTradeRatiosState: shouldShowBankTradeRatio ? myBankTradeRatioState : undefined
    }))), /*#__PURE__*/ React.createElement("div", {
        className: styles.rightContainer
    }, shouldShowMerchant && merchantState.activeTradeBonus != null && /*#__PURE__*/ React.createElement("div", {
        className: styles.merchantWrapper
    }, /*#__PURE__*/ React.createElement(UIGameCard, {
        cardEnum: merchantState.activeTradeBonus,
        className: styles.card,
        size: isPortraitLayout ? 'sm' : 'base'
    }), /*#__PURE__*/ React.createElement("img", {
        className: styles.merchantIcon,
        src: MERCHANT_IMAGE_PATH[myColor]
    }))));
};
